import styled from 'styled-components'
import { P } from './Typography'

import Twitter from '../assets/images/twitterf.png'

import Discord from '../assets/images/discordf.png'

import Chat from '../assets/images/chatf.png'

const Wrapper = styled.div`
  margin-left: 100px;
  margin-right: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export default function Footer() {
  return (
    <>
      <Wrapper>
        <div>
          <P color="#5C1A00">© 2o23 Bichi Mao. All rights reserved.</P>
        </div>
        <div>
          <img style={{ cursor: 'pointer' }} src={Discord} alt="" />
          <img style={{ cursor: 'pointer' }} className="mx-3" src={Twitter} alt="" />
          <img style={{ cursor: 'pointer' }} src={Chat} alt="" />
        </div>
      </Wrapper>
    </>
  )
}
